import { createFileRoute } from "@tanstack/react-router";
import { TutorsMapPage } from "@/components/partners/TutorsMapPage";
import { tutorsMapHead } from "@/components/partners/tutors-map-head";
import { loadTutorsMapPage } from "@/components/partners/partner-route";

// Карта «Рядом с домом» (en). Индексный маршрут — не рамка для /tutors/join.
export const Route = createFileRoute("/en/tutors/")({
  // Рекомендуемые и фильтры из адреса — тоже здесь: блок рисуется в SSR (partner-route.ts).
  loader: ({ location }) => loadTutorsMapPage(location.searchStr),
  head: ({ loaderData }) => tutorsMapHead("en", undefined, undefined, loaderData?.list?.rows),
  component: function Page() {
    const { list, featured, query } = Route.useLoaderData();
    return <TutorsMapPage lang="en" initial={list} featured={featured} query={query} />;
  },
});
